class Search {
    constructor() {
        this.searchBtn  = document.querySelector('.js-open-search');
        this.searchForm = document.querySelector('.js-search');
        console.log(this.searchForm);
        this.bindEvents();
    }

    bindEvents() {
        this.toggleSearch();
    }

    toggleSearch() {
        this.searchBtn.addEventListener('click', (el) => {
            console.log(el);
            this.searchBtn.classList.toggle('is-open')
            this.searchForm.classList.toggle('is-open')
        })
    }

}

new Search();
